<template>
  <h1 class="text-center">OrderDetail Pages</h1>
</template>

<script>
export default {
  name: "OrderDetailPages"
}
</script>

<style scoped>

</style>